export default "__VITE_ASSET__BxcSRZy___"